import BaseService from './core/base.service';
import { SERVICE_NAMES } from './core/service-names';

class FluidService extends BaseService {
  async getDashboard() {
    const response = await this.repository.getDashboard();
    return this.handleResponse(response);
  }

  async getReadings(params) {
    const response = await this.repository.getReadings(params);
    return this.handleResponse(response);
  }

  async getReading(mainUnique) {
    const response = await this.repository.getReading(mainUnique);
    return this.handleResponse(response);
  }

  async createReading(payload) {
    const response = await this.repository.createReading(payload);
    return this.handleResponse(response);
  }

  async updateReading(mainUnique, payload) {
    const response = await this.repository.updateReading(mainUnique, payload);
    return this.handleResponse(response);
  }

  async deleteReading(mainUnique) {
    const response = await this.repository.deleteReading(mainUnique);
    return this.handleResponse(response);
  }

  async requestDryWeight(payload) {
    const response = await this.repository.requestDryWeight(payload);
    return this.handleResponse(response);
  }

  async getAttendance() {
    const response = await this.repository.getAttendance();
    return this.handleResponse(response);
  }

  async saveAttendance(payload) {
    const response = await this.repository.saveAttendance(payload);
    return this.handleResponse(response);
  }

  async getReminders() {
    const response = await this.repository.getReminders();
    return this.handleResponse(response);
  }

  async createReminder(payload) {
    const response = await this.repository.createReminder(payload);
    return this.handleResponse(response);
  }

  async updateReminder(itemUnique, payload) {
    const response = await this.repository.updateReminder(itemUnique, payload);
    return this.handleResponse(response);
  }

  async deleteReminder(itemUnique) {
    const response = await this.repository.deleteReminder(itemUnique);
    return this.handleResponse(response);
  }

  async getNotificationContext(params) {
    const response = await this.repository.getNotificationContext(params);
    return this.handleResponse(response);
  }

  async dismissAlert(itemUnique) {
    const response = await this.repository.dismissAlert(itemUnique);
    return this.handleResponse(response);
  }

  async reviewDryWeight(prescriptionItemUnique, request) {
    const response = await this.repository.reviewDryWeight(prescriptionItemUnique, request);
    return this.handleResponse(response);
  }
}

export default new FluidService(SERVICE_NAMES.FLUID);
